// src/viqai/ViqSignedOut.jsx
// ─── Accueil de user.vehicleiq.fr sans session ──────────────────────────────
// L'écran précédent était une carte beige flottante au centre d'une page vide,
// avec « Connectez-vous pour accéder à vos Dossiers VIQ ». Il ressemblait à une
// page d'erreur technique — or c'est souvent le premier écran qu'un
// professionnel voit du produit.
//
// Ici : la promesse, un aperçu abstrait de la conversation (jamais de fausses
// données véhicule — un faux résultat crédible sur un écran public est une
// promesse qu'on n'a pas encore tenue), et deux entrées claires.

import "./viqai-dark.css";

export default function ViqSignedOut({ onLogin, onSignup, onLegal }) {
  return (
    <div className="viq-signedout viq-dark">
      <div className="viq-so-inner">
        <div className="viq-so-left">
          <div className="viq-so-brand">VehicleIQ</div>
          <div className="viq-so-eyebrow">Intelligence automobile professionnelle</div>

          <h1 className="viq-so-title">Votre espace VIQ.AI</h1>
          <p className="viq-so-sub">
            Retrouvez vos conversations, vos véhicules et votre intelligence métier.
            Un seul endroit où demander, analyser et décider.
          </p>

          <div className="viq-so-cta">
            <button type="button" className="viq-btn primary" onClick={onSignup}>Créer un compte</button>
            <button type="button" className="viq-btn" onClick={onLogin}>Se connecter</button>
          </div>

          <div className="viq-so-note">7 jours gratuits · sans engagement</div>
        </div>

        {/* Aperçu abstrait : la forme du produit, sans donnée inventée. */}
        <div className="viq-so-right" aria-hidden="true">
          {/* Même ligne de carrosserie que la landing, derrière l'aperçu :
              l'univers automobile est rappelé sans photo ni logo. */}
          <svg className="viq-so-silhouette" viewBox="0 0 900 300" aria-hidden="true" focusable="false">
            <path d="M30 230 L100 230 C126 230 138 190 180 175 C252 150 320 140 396 138
                     C472 136 540 145 608 160 C676 175 744 197 802 205 L860 213"
                  fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M214 170 C266 112 334 90 418 88 C502 86 578 108 630 160"
                  fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <circle cx="272" cy="230" r="42" fill="none" stroke="currentColor" strokeWidth="2.5" />
            <circle cx="716" cy="230" r="42" fill="none" stroke="currentColor" strokeWidth="2.5" />
          </svg>
          <div className="viq-so-preview">
            <div className="viq-so-line viq-so-user" />
            <div className="viq-so-steps">
              <span /><span /><span />
            </div>
            <div className="viq-so-card">
              <div className="viq-so-bar w70" />
              <div className="viq-so-bar w45" />
              <div className="viq-so-bar w60" />
              <div className="viq-so-bar accent w35" />
            </div>
            <div className="viq-so-line w80" />
            <div className="viq-so-composer">
              <span className="viq-so-ph">Demandez quelque chose à VIQ.AI…</span>
              <span className="viq-so-send">➜</span>
            </div>
          </div>
        </div>
      </div>

      {/* §12 — Les liens légaux ne disparaissent jamais, y compris sans session.
          Ils appellent les modales existantes : rien n'est recréé. */}
      <div className="viq-legal viq-so-legal">
        {[["Mentions légales", "Mentions", "mentions"],
          ["Politique de confidentialité", "Confidentialité", "privacy"],
          ["CGU / Confidentialité", "CGU", "cgu"],
          ["Conditions Générales de Vente", "CGV", "cgv"]].map(([full, short, key], i, arr) => (
          <span key={key}>
            <button type="button" title={full} onClick={() => onLegal && onLegal(key)}>
              <span className="legal-full">{full}</span>
              <span className="legal-short">{short}</span>
            </button>
            {i < arr.length - 1 && <span aria-hidden="true">·</span>}
          </span>
        ))}
      </div>
    </div>
  );
}
